
import './App.css';
import { Routes, Route } from 'react-router-dom';
import React, { lazy, Suspense } from 'react';
import NavBarNew from './components/CourseNav/NavBarNew';
import FirstScreen from './screens/NewFirstScreen';
import SecondScreen from './screens/SecondScreen';

// Lazy load below-the-fold components
const Works = lazy(() => import('./components/recommends/Works'));
const Me = lazy(() => import('./components/me/Me'));
const Certificates = lazy(() => import('./components/recommends/Certificates'));
const ThirdScreen = lazy(() => import('./screens/ThirdScreen'));
const StudentsWorks = lazy(() => import('./components/recommends/StudentsWorks'));
const ForthScreen = lazy(() => import('./screens/ForthScreen'));
const SixthScreen = lazy(() => import('./screens/SixthScreen'));
const FifthScreen = lazy(() => import('./screens/FifthScreen'));
const PrivacyPolicy = lazy(() => import('./privacy/Privacy'));
const ByMe = lazy(() => import('./components/ByMe/ByMe'));
const LandingPage = lazy(() => import('./screens/LandingPage'));

function HomePage() {
  return <>
    <NavBarNew/>
    <FirstScreen/>
    <SecondScreen/>
    <Suspense fallback={null}>
      <Works/>
      <Me/>
      <Certificates/>
      <ThirdScreen/>
      <StudentsWorks/>
      <ForthScreen/>
      <SixthScreen/>
      <FifthScreen/>
      <PrivacyPolicy
        ownerName="שלי מאיר"
        email="shelimeir998@gmail.com"
        phone="053-621-6926"
        domain="https://shelimeir-academy.co.il/"
      />
      <ByMe/>
    </Suspense>
  </>;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/campaign" element={<Suspense fallback={null}><LandingPage /></Suspense>} />
    </Routes>
  );
}

export default App;
